import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';
import 'react-image-lightbox/style.css';
import config from './config';
import './react-day-picker.css';
import Root from './Root';
import services from './services/services';
import * as serviceWorker from './serviceWorker';
import './styles.css';

// start errors service ( sentry )
services.errors.start();

console.log(`pms-web started --- NODE_ENV: ${process.env.NODE_ENV} - PMS_ENV: ${config.env}`);

ReactDOM.render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={'An error has occurred'}>
      <Root />
    </Sentry.ErrorBoundary>
  </StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
